module.exports = __webpack_public_path__ + "img/circle-three-quarters.50224f95.svg";